import { signers } from "rujira.js";
import { setupAuthExtension } from "rujira.js/src/signers/cosmos/modules/auth/queries";
import { setupThorchainExtension } from "rujira.js/src/signers/cosmos/modules/thorchain/queries";
import { setupTxExtension } from "rujira.js/src/signers/cosmos/modules/tx/queries";
import { Comet38Client } from "rujira.js/src/signers/cosmos/rpc/comet38";

const cometClient = Comet38Client.connect(
  import.meta.env.MODE === "main"
    ? "https://rpc.rujira.network"
    : "https://rpc-stagenet.rujira.network"
);
export const QUERY_CLIENT = signers.cosmos.QueryClient.withExtensions(
  cometClient,
  setupAuthExtension,
  setupTxExtension,
  setupThorchainExtension
);
